import { render, staticRenderFns } from "./EInvoiceDetail.vue?vue&type=template&id=65c53e88&"
import script from "./EInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./EInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports